import React from "react";
import { Link } from "react-router-dom";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

const SubSideBar = (props) => {
  const { name, icon, subSideBar } = props.data;

  return (
    <>
      <UncontrolledDropdown nav>
        <DropdownToggle nav className="nav-link-icon">
          <i className={icon} />
          {name}
        </DropdownToggle>
        <DropdownMenu
          aria-labelledby="navbar-default_dropdown_1"
          className="dropdown-menu-arrow"
          right
        >
          {subSideBar.map((subItem) => {
            return (
              <DropdownItem
                tag={Link}
                to={subItem.layout + subItem.path}
                key={subItem.name}
              >
                <i className={subItem.icon} />
                {subItem.name}
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
};

export default SubSideBar;
